export default __webpack_public_path__ + "static/media/ico-file.bac71ab6.svg";